import { browserHistory } from 'react-router';


export const openBinderUnfiledDocuments = (binder) => {
    let toLocation = `/binder/${binder.id}/files?folder=unfiled&o=-1&offset=0&q=&s=uploadDate`;
    browserHistory.push(toLocation);
};
export const openBinderPendingTasks = (binder) => {
    let toLocation = `/binder/${binder.id}/tasks/incomplete`;
    browserHistory.push(toLocation);
};

export const goBackHome = () => {
    browserHistory.push('/');
};

export const openStudy = (study, setRowData, setIsDrawerOpen) => {
    let toLocation = `/study/${study.id}`;
    study.binderId ? browserHistory.push(toLocation) : setIsDrawerOpen(true);
    !study.binderId && setRowData(study); 
};
export const openStudyUnfiledDocuments = (study) => {
    let toLocation = `/study/${study.id}/documents?folder=unfiled&o=-1&offset=0&q=&s=uploadDate`;
    browserHistory.push(toLocation);
}; 
export const openStudyPendingTasks = (study) => {
    let toLocation = `/study/${study.id}/tasks/pending`;
    browserHistory.push(toLocation);
};

export const openBinder = (binder) => {
    let toLocation = `/binder/${binder.id}/files`;

    if (!binder.status || binder.status.toLowerCase() === 'new') {
        toLocation = `/binder/${binder.id}/setup`;
    }

    browserHistory.push(toLocation);
};

export function getBinderLink(rowData, path) {
    const { isBinder, status, id = null } = rowData;

    // draft binder
    if(status &&status.toLowerCase() === 'draft') {
        return `${path}/draft/${id}`;
    }

    if(isBinder) {
        return `/binder/${id}`;
    }

    return `/study/${id}`;
}